 import {coreColors} from '../../../styles/shared/variables'
 export const tabsContainerStyle= {
    background: coreColors.grey400,
    tabType: 'scrollable',
    marginTop: 200,
    left: 0,
    color: '#fff',
    indicator: '#30ACFF'
 }



// WEBPACK FOOTER //
// ./src/tabs/appBars/styles/desktopStyle.js